import { message } from "antd";
import { SUBMITCONTACT } from "../constants/contactContants";
import * as api from "../../api/index";

export const submitForm = (formData) => async (dispatch) => {
  try {
    const { data } = await api.submitForm(formData);
    dispatch({ type: SUBMITCONTACT, data });
    if (data.success === true) {
      message.success("Message send successfully");
    }
  } catch (error) {
    if (error) {
      console.log(error);
      message.error(error?.response?.data?.message);
    }
  }
};
